export enum VATOptionEnum {
  FRANCE = 'FRANCE',
  OUTSIDE_EU = 'OUTSIDE_EU',
  EU = 'EU'
}

export const VATOptionEnumMapping: Record<VATOptionEnum, string> = {
  FRANCE: 'France',
  OUTSIDE_EU: 'Hors UE',
  EU: 'UE'
}
